export function doesAccountNameSatisfyQuery(
  accountName: string,
  query: string
): boolean {
  if (!accountName || !query) {
    return false
  }

  return accountName.toLowerCase().includes(query.toLowerCase())
}
